import React from "react";

const labels = {
  in_stock: "In Stock",
  expiring_soon: "Expiring",
  expired: "Expired",
  shipped: "Shipped",
  scheduled: "Scheduled",
  cancelled: "Cancelled",
};

export default function StatusPill({ status }) {
  const cls = `pill pill-${status}`;
  return (
    <span className={cls} data-testid={`status-pill-${status}`}>
      {labels[status] || status}
    </span>
  );
}
